var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image720-page"},[(_vm.src)?_c('UAVPanorama',{key:_vm.src,attrs:{"src":_vm.src,"height":"100vh","show-annotations":false,"option":_vm.panoramaOption}}):_c('div',{staticClass:"empty-state"},[_vm._v("请提供全景照片地址（?src=...）")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }